module.exports = __webpack_public_path__ + "media/images/lb/730-374281a8e4084128d97fd3b10faa96c5.svg";